const normalizeEdgeValue = (value, min, max) => max === min ? 0 : (value - min) / (max - min);
export default normalizeEdgeValue;
